import React				from 'react';
import BLComponent			from '../../core/_BLComponent.jsx';

import { ItemDetailInfo, ItemTypeNameUtil, Page, ItemListUtil } from '../controller/MyCollectionUtils.js';
import NothingToShow 		from './_NothingToShow.jsx';

export default class GridView extends BLComponent 
{
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 
		this.state = {
			focusOn: -1
		}
	}

	componentDidUpdate() {
		const focusOn = this.state.focusOn;
		
		if (focusOn != -1) {
			const area = document.getElementById("TextareaNote-" + focusOn);
			if (area != null) 
			{
				area.focus();
				area.selectionStart = area.value.length;
			}
			this.setState({focusOn:-1});
		}
		
	}

	render()
	{
		const {listItem, dispItemType, strSearchKeyword}  = this.props.data;
		let strGridClass = (dispItemType == "P")?"personal-inventory__list-item-part-grid":"personal-inventory__list-item-grid";
		let listItemVew = this.getItemView(listItem, dispItemType);
		let isEmpty = true;

		for( const item of listItem) {
			if (item.invQty > 0) isEmpty = false;
		}

		if (isEmpty)
		{
			return(
				<NothingToShow data={{itemType:dispItemType, strSearchKeyword: strSearchKeyword}}/>
			)
		}
		else
		{
			return(
				<section className="personal-inventory__list-body l-margin-top">
					<div className={strGridClass}>
						{listItemVew}
					</div>
				</section>
			)
		}
	}

	showDelIcon(idx) {
		$("#icon-delete-" + idx).addClass("l-block");
	}

	hideDelIcon(idx) {
		$("#icon-delete-" + idx).removeClass("l-block");
	}

	getItemView(listItem, dispItemType) {
		const {showCategoryTree} = this.props.data;
		let listItemView = listItem.map( (item, idx) => {
			const { itemType, note, bQtyError, strItemCondition, bQtyUpdated, bNoteUpdated, bNoteEnabled, qty } = ItemDetailInfo.getInfo(item);
			const bEditExistingNote = ( (note != "") && bNoteEnabled )?true:false;
			const borderStyle = (bNoteUpdated)?"personal-inventory__border-thick--blue":(bEditExistingNote)?"personal-inventory__border-thick--yellow":"";
			return(
				<div
					key={"itemCard-" + idx}  
					className={"l-cursor-pointer personal-inventory__item-card" + ((bQtyUpdated && !bQtyError)?"--qty-updated":(bQtyUpdated && bQtyError)?"--qty-update-err":"" ) + " l-relative " + borderStyle } 
					onMouseEnter={()=>this.showDelIcon(idx)} 
					onMouseLeave={()=>this.hideDelIcon(idx)}
				>
					<div id={"grid-item-" + idx} className="personal-inventory__section-grid-item-detail" onMouseDown={(e)=>this.moveToItemDetail(e, item, idx)} >
						<div id={"icon-delete-"+idx} className={"icon-delete " + ((item.markedAsDeletion)?" personal-inventory__icon-delete-marked":" personal-inventory__icon-delete-grid") + " personal-inventory__absolute" + ((bQtyUpdated)?" text--disabled":"")}>
							<div className="icon-delete l-margin-y--auto l-flex l-center-v l-center l-full-height"><i className="fa-regular fa-trash-can icon-delete"></i></div>
						</div>
						<div className={(showCategoryTree && (itemType == "P"))?"personal-inventory__item-card-image--sm":"personal-inventory__item-card-image"}>
							<img 
								className={"personal-inventory__grid-image" + ( (showCategoryTree && (itemType == "P"))?"--sm":" " ) + ( (bNoteEnabled)?"shrink-image":"") } 
								id={"itemImg-" + idx} 
								src={item.thumbUrl} 
								onError={()=>this.imgErrorProc(idx) }
							/>
							<div id={"noItemImg-"+idx} className="l-center-v l-full-height l-full-width text--center l-hide">
								<div className="l-margin-y--auto l-flex l-center-v l-center l-full-height">
									<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fillRule="evenodd" clipRule="evenodd" d="m30.495 9.505-.623-.624A3 3 0 0 0 27.753 8H15A3.01 3.01 0 0 0 12 11.006V28l3-3V11.007h9.997v3.997l3-3v-.754l.377.377 2.121-2.121zM17.313 34l4.842-4.842.843.843 5.467-5.468a.75.75 0 0 1 1.063 0l1.468 1.469V34H17.313zm-2.314 2.313v.687h17.997V19.004h-.686l3.572-3.572c.074.264.113.539.113.816v20.753a3 3 0 0 1-3 2.999H15a2.996 2.996 0 0 1-2.436-1.25L15 36.314zm5.869-17.182a3 3 0 0 0-3.74 3.74l3.74-3.74zM37.414 8.414a2 2 0 0 1 0 2.829L10.243 38.414a2 2 0 1 1-2.829-2.828L34.586 8.414a2 2 0 0 1 2.828 0z" fill="#0A1E32"/>
									</svg>
								</div>
							</div>
						</div>
						{this.renderItemNoName(item, itemType)}
						
						<div className="l-flex l-split">
							<div>&nbsp;</div>
							<div className="text--center personal-inventory__item-card-qty personal-inventory__text--sm">Qty</div>
						</div>
						<div className="l-flex l-split">
							<div className="l-flex l-column l-center-v personal-inventory__text--sm">
								{strItemCondition}
							</div>
							<div className="personal-inventory__item-card-qty">		
								<input className={"inp-qty text-input text-input--sm text--center " + (item.markedAsDeletion?"text--disabled":"")} disabled={item.markedAsDeletion} type="number" value={qty} onKeyPress={(e)=>this.checkKey(e)} onChange={(e)=>this.props.func.updateItemQty(idx, e.target.value)}/>
							</div>
						</div>
					</div>
					{this.renderNoteContent(item,idx)}
				</div>
			)
		} );
		return listItemView;
	}

	enableEditNote(idx, bMarkedAsDeletion) {
		const item = document.getElementById("SectionEditNote-" + idx);
		const itemImg = document.getElementById("itemImg-" + idx);
		
		item.classList.toggle("active-note");
		itemImg.classList.toggle("shrink-image");
		if (!bMarkedAsDeletion) {
			this.setState({focusOn: idx});
			this.props.func.enableEditNote(idx);
		}
	}

	renderNoteContent(item, idx) {
		const { note, newNote, bNoteEnabled, bNoteUpdated, bMarkedAsDeletion } = ItemDetailInfo.getInfo(item);
		const notesToDisplay = (bNoteUpdated)?newNote:note;
		const maxNoteLen = this.props.data.myCollectionConfig.maxNoteLen;
		const notesInTextareaLen = notesToDisplay.length;
		const bExistingNotesUnchanged = ( ( note != "") && !bNoteUpdated )?true:false;
		
		const bEditExistingNote = ( (note != "") && bNoteEnabled )?true:false;
		const borderStyle = (bNoteUpdated)?"personal-inventory__border-thick--blue":(bEditExistingNote)?"personal-inventory__border-thick--yellow":"";
		
		if (bNoteEnabled) {
			return (
				<div 
					id={"SectionEditNote-" + idx}
					className={"personal-inventory__section-note-textarea l-margin-top--sm personal-inventory__section-grid-note active-note " + borderStyle }
				>
					<div className="l-full-height l-flex l-split l-column">
						<div className="l-flex l-split">
							<div onClick={()=>this.enableEditNote(idx, bMarkedAsDeletion)}><i className="fa-regular fa-square-minus"></i></div>
							<div className="l-pad-bottom--sm text--small text--right text--darkest48">{notesInTextareaLen}/{maxNoteLen}</div>
						</div>
						<textarea
							id={"TextareaNote-" + idx} 
							className={"l-full-height personal-inventory__textarea-note l-border--null l-full-width l-pad-y--sm cls-txtarea-note TextareaNote-" + idx }
							maxLength={maxNoteLen} 
							onKeyUp={(e) => this.updateNoteContent(idx, newNote, e)}
							defaultValue={notesToDisplay}
							placeholder="Type your notes here"
							disabled={bMarkedAsDeletion}
						>
						</textarea>
					</div>
				</div>
			)
		}
		else {
			const strNotes = (notesToDisplay == "")?"Add notes":notesToDisplay;
			return(
				<div 
					id={"SectionEditNote-" + idx} 
					className={"l-margin-top--sm  personal-inventory__section-grid-note l-flex " + ((bExistingNotesUnchanged)?"personal-inventory__bg--gold":(bNoteUpdated)?"personal-inventory__bg--blue":"") + ((bNoteUpdated)?" personal-inventory__text--white":"")}
					onClick={()=>this.enableEditNote(idx, bMarkedAsDeletion)}
				>
					<button className={"btn btn--blank " + ( (bMarkedAsDeletion)?"text--disabled":"" )}><i className="far fa-edit"></i></button>
					<div className={"l-margin-left--sm overflow-ellipsis"}>{strNotes}</div>
				</div>
			)
		}
	}

	updateNoteContent(idx, newNote, e) {
		if (e.target.value != newNote) {
			e.target.style.height = 'inherit';
			e.target.style.height = e.target.scrollHeight + "px"; 
			
			this.props.func.updateNoteContent(idx, e.target.value);
			const arrTextArea = document.getElementsByClassName("TextareaNote-" + idx);
			for (var i = 0; i < arrTextArea.length;i++) {
				arrTextArea[i].value = e.target.value;
			}
		}
	}

	moveToItemDetail(e, item, idx){
		let bQtyUpdated = (typeof item.newQty == "undefined")?false:(item.newQty != item.invQty)?true:false;
		if($(e.target).hasClass("icon-delete")) {
			if (!bQtyUpdated) this.props.func.markAsDeletion(idx, !item.markedAsDeletion);
			return null;
		}
		if($(e.target).hasClass("inp-qty")) {
			return null;
		}
		else
		{
			let itemNoSeq = item.itemNo;
			if (item.itemSeq >= 1) {
				itemNoSeq = itemNoSeq + "-" + item.itemSeq;
			}
			
			let clickURL = "//" + blapp.config.getHost( "www" ) + "/v2/catalog/catalogitem.page?" + item.itemType + "=" + itemNoSeq;
			
			window.location.href = clickURL;
		}
	}
	imgErrorProc(idx) {
		$("#itemImg-" + idx).hide();
		$("#noItemImg-" + idx).show();
	}

	renderItemNoName(item) {
		const { itemName, itemType, itemNoSeq, itemColorName } = ItemDetailInfo.getInfo(item);
		if ( itemType != "P" ) {
			return (
				<div>
					<div className="personal-inventory__item-card-itemNo personal-inventory__text--sm l-margin-top">
						{itemNoSeq}
					</div>
					<div className="personal-inventory__item-card-item-name text--bold">
						{itemName}
					</div>
				</div>
			)
		}	
		else {
			return (
				<div>
					<div className="personal-inventory__item-card-item-name personal-inventory__text--sm l-margin-top">
						<strong>{itemNoSeq}</strong> : {itemName}
					</div>
					<div className="personal-inventory__item-card-color-name personal-inventory__text--sm">
						{itemColorName}
					</div>
				</div>
			)
		}	
	}

	checkKey(e)
	{
		if (event.key === 'Enter') {
			this.props.func.saveInvChanges();
		}
	}

};

